import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Home, Wallet, Bell, UserCircle2, MoreHorizontal } from "lucide-react";
import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";

export default function TabBar() {
  const { user, requireAuth } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);

  const loadUnread = useCallback(async () => {
    if (!user) { setUnread(0); return; }
    try {
      const r = await api.unreadCount();
      setUnread(r.count);
    } catch {}
  }, [user]);

  useEffect(() => {
    loadUnread();
    const t = setInterval(loadUnread, 20000);
    return () => clearInterval(t);
  }, [loadUnread, pathname]);

  // Don't render tab bar on auth screens themselves.
  if (pathname === "/login" || pathname === "/register") return null;

  const gatedClick = (path) => (e) => {
    if (user) return; // let NavLink handle navigation
    e.preventDefault();
    requireAuth(() => navigate(path));
  };

  return (
    <nav className="tab-bar" data-testid="tab-bar">
      <NavLink to="/" end className={({ isActive }) => `tab-item ${isActive ? "active" : ""}`} data-testid="tab-home">
        <Home size={22} />
        <span>Home</span>
      </NavLink>
      <NavLink
        to="/cashout"
        onClick={gatedClick("/cashout")}
        className={({ isActive }) => `tab-item ${isActive ? "active" : ""}`}
        data-testid="tab-cashout"
      >
        <Wallet size={22} />
        <span>Withdraw</span>
      </NavLink>
      <NavLink
        to="/inbox"
        onClick={gatedClick("/inbox")}
        className={({ isActive }) => `tab-item ${isActive ? "active" : ""}`}
        data-testid="tab-inbox"
      >
        <Bell size={22} />
        <span>Inbox</span>
        {unread > 0 && <span className="badge" data-testid="tab-inbox-badge">{unread > 9 ? "9+" : unread}</span>}
      </NavLink>
      <NavLink
        to="/more"
        onClick={gatedClick("/more")}
        className={({ isActive }) => `tab-item ${isActive ? "active" : ""}`}
        data-testid="tab-more"
      >
        <MoreHorizontal size={22} />
        <span>More</span>
      </NavLink>
      <NavLink to="/profile" className={({ isActive }) => `tab-item ${isActive ? "active" : ""}`} data-testid="tab-profile">
        <UserCircle2 size={22} />
        <span>Profile</span>
      </NavLink>
    </nav>
  );
}
